import TValidations from "cms/types/TValidations";
import { EView } from "cms/enums/EView";
import { EViewType } from "cms/enums/EViewType";
import ILanguageVersionList from "cms/interfaces/ILanguageVersionList";
import React, { useEffect, useRef } from "react";
import { isEmpty } from "lodash";
import { connect, ConnectedProps } from "react-redux";
import ContactUsServiceAction from "cms/actions/components/ContactForm/ContactUsServiceAction";
import MessagePublisherAction from "core/actions/common/MessagePublisherAction";
import IClientLanguage from "core/interfaces/IClientLanguage";
import IBase from "cms/interfaces/IBase";
import { Dispatch } from "@reduxjs/toolkit";
import RMDRTextBox from "./RMDRTextBox";
import RMDRTextArea from "./RMDRTextArea";
import LanguageVersionSelector from "cms/utilities/LanguageVersionSelector";
import ILanguageVersionDetail from "cms/interfaces/ILanguageVersionDetail";
import { EContentType } from "cms/enums/EContentType";
import cn from "classnames";


function mapStateToProps ( state: any ) {
    console.log("MNPG008.mapStateToProps: ", state);

    const webApplicationLanguage:IClientLanguage   = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string        = webApplicationLanguage.code;
    const webApplicationLanguageISOCode:string     = state.CoreStore.languageCode?.payload;

    const contactUsPostPayload:IBase                            = state.ContactFormStore.ContactUsStore.post.payload;
    const contactUsPostError:TValidations[]|null                = state.ContactFormStore.ContactUsStore.post.error?.value;
    const contactUsPostIsLoading:boolean                        = state.ContactFormStore.ContactUsStore.post.isLoading;

    return {

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        contactUsPostPayload,
        contactUsPostError,
        contactUsPostIsLoading,
    
    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("MNPG008.mapDispatchToProps");

    const messagePublisherAction = new MessagePublisherAction(dispatch);
    const contactUsServiceAction = new ContactUsServiceAction(dispatch);

    return {

        _post: ( payload: { nameSurname:string|null, email:string|null, title:string|null, message:string|null }, webApplicationLanguageCode:string ) => {
            contactUsServiceAction.post({ servicePayload: { body: payload, language: webApplicationLanguageCode } });
        },

        _showMessage: ( message:string ) => { 
            messagePublisherAction.showSuccessMessage(message);
        },

        _clean: () => {
            contactUsServiceAction.postClean();
        }

    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>

type TContactForm<T> = {

    languageVersions?:ILanguageVersionList[]|null;
    className?:string;

} & T;

/* component */
function ContactFormLoader () {

    return (
        <></>
    )

}

function ContactForm ( props:TContactForm<PropsFromRedux> ) {
    console.log("ContactForm.rendered: ", props);

    const contactUsNameSurname = useRef<any>(null);
    const contactUsEmail = useRef<any>(null);
    const contactUsMessage = useRef<any>(null);
    const contactUsTitle = useRef<any>(null);

    const enterYourNameString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "enterYourNameString" }
        ],
        type: "find"
    });
    
    const enterYourEmailString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "enterYourEmailString" }
        ],
        type: "find"
    });

    const enterYourTitleString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "enterYourTitleString" }
        ],
        type: "find"
    });

    const writeYourMessageString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "writeYourMessageString" }
        ],
        type: "find"
    });

    const sendMessageString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "sendMessageString" }
        ],
        type: "find"
    });

    const sendingMessageString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "sendingMessageString" }
        ],
        type: "find"
    });

    const messageHasBeenSentString = LanguageVersionSelector<ILanguageVersionDetail|null>({
        languageVersions: props.languageVersions,
        filters: [
            { view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "messageHasBeenSentString" }
        ],
        type: "find"
    });

    useEffect(
        () => {

            return () => {
                props._clean();
            }

        }, []
    )

    useEffect(
        () => {
            if ( !isEmpty(props.contactUsPostPayload?.id) ) {
                contactUsNameSurname.current.value = "";
                contactUsEmail.current.value = "";
                contactUsMessage.current.value = "";
                contactUsTitle.current.value = "";

                props._clean();
                props._showMessage(messageHasBeenSentString?.value||"");
                
            }
        }, [ props.contactUsPostPayload ]
    )

    function onSubmit(event:React.SyntheticEvent) { 
        event.preventDefault();

        const target = event.target as typeof event.target & {
            nameSurname: { value: string },
            title: { value: string },
            email: { value: string },
            message: { value: string },
        };

        const payload:any = {
            nameSurname: target.nameSurname.value,
            email: target.email.value,
            message: target.message.value,
            title: target.title.value,
        }
        
        props._post(payload, props.webApplicationLanguageCode);
    }

    return (
        <form className={cn("contact-form-validated", props.className)} onSubmit={onSubmit} noValidate>
            <div className="row">
                <div className="col-xl-6 col-lg-6 md:!tw-pr-2">
                    <div className="contact-three__input-box">
                        <RMDRTextBox 
                            rmdrRef={contactUsNameSurname} 
                            name="nameSurname" 
                            placeholder={enterYourNameString?.value} 
                            disabled={props.contactUsPostIsLoading} 
                            errors={props.contactUsPostError} 
                        />
                    </div>
                </div>
                <div className="col-xl-6 col-lg-6 md:!tw-pl-2">
                    <div className="contact-three__input-box">
                        <RMDRTextBox 
                            rmdrRef={contactUsEmail} 
                            name="email" 
                            placeholder={enterYourEmailString?.value} 
                            disabled={props.contactUsPostIsLoading} 
                            errors={props.contactUsPostError}
                        />
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="contact-three__input-box">
                        <RMDRTextBox 
                            rmdrRef={contactUsTitle} 
                            name="title" 
                            placeholder={enterYourTitleString?.value} 
                            disabled={props.contactUsPostIsLoading} 
                            errors={props.contactUsPostError} 
                        />                                        
                    </div>
                </div>
            </div>
            <div className="row">
                <div className="col-xl-12 col-lg-12">
                    <div className="contact-three__input-box text-message-box">
                        <RMDRTextArea
                            rmdrRef={contactUsMessage}
                            name="message" 
                            placeholder={writeYourMessageString?.value}
                            disabled={props.contactUsPostIsLoading} 
                            rows={6}
                            errors={props.contactUsPostError}
                        />
                    </div>
                    <div className="contact-three__btn-box">
                        <button type="submit" className="thm-btn contact-three__btn" disabled={props.contactUsPostIsLoading}>
                            { props.contactUsPostIsLoading ? sendingMessageString?.value : sendMessageString?.value  }
                            <span className="icon-dabble-arrow-right"></span>
                        </button>
                    </div>
                </div>
            </div>
        </form>
    );
};

ContactForm.defaultProps = {

    className: "contact-three__form"

}

const Component = React.memo(ContactForm, ( prevProps:TContactForm<PropsFromRedux> , nextProps:TContactForm<PropsFromRedux> ) => {
    console.log("ContactForm.memo", { prevProps, nextProps });

    return !(
        prevProps.contactUsPostPayload !== nextProps.contactUsPostPayload
        || prevProps.contactUsPostError !== nextProps.contactUsPostError
    );
});

export default connector(Component);
